import React from 'react';
import "./ErrorComponent.css"
function ErrorComponent({ message }) {
    if (!message) return null;

    return (
        <div className="errorField" aria-live="polite">
            <span role="img" aria-label="warning" className="warningSign">⚠️</span>
            <span className="errorText">{message}</span>
        </div>
    );
}

export default ErrorComponent;
